const sensor = {
    no2: "NO2",
    no: "NO",
    o3: "O3",
    co2: "CO2",
    co: "CO",
    so2: "SO2",
    h2s: "H2S",
    nh3: "NH3",
    pm1: "PM1",
    pm2p5: "PM2P5",
    pm4: "PM4",
    pm10: "PM10",
    pm40: "PM40",
    hcl: "HCL",
    voc: "VOC",
    pvoc: "pVOC",
    voc_iaq: "VOC_IAQ",
    noise: "noise",
    temperature: "temperature",
    rh: "relativeHumidity",
    ah: "absoluteHumidity",
    temperature_meteo: "temperatureMeteo",
    rh_meteo: "relativeHumidityMeteo",
    pressure: "pressure",
    equivalent_pressure: "equivalentPressure",
    rain_rate: "rainRate",
    solar_radiation: "solarRadiation",
    uv_index: "uvIndex",
    wind: "wind",
    wind_speed: "windSpeed",
    wind_gust: "windGust",
    wind_direction: "wdirection",
    battery: "battery",
    aqi: "aqi",
    noise_a: "noiseA",
    noise_c: "noiseC",
    noise_z: "noiseZ",
};

const unit = {
    ppb: "ppb",
    ppm: "ppm",
    ug_m3: "ug-m3",
    mg_m3: "mg-m3",
    celsius: "celsius",
    percentage: "percentage",
    fahrenheit: "fahrenheit",
    mps: "mps",
    mph: "mph",
    knots: "knots",
    degrees: "degrees",
    hpa: "hPa",
    dba: "dBA",
    dbc: "dBC",
    dbz: "dBZ",
    iaq: "IAQ",
    mm_h: "mm/h",
    w_m2: "W/m²",
    uv: "UV"
};

const indexList = {
    AQI: "AQI",
    EAQI: "EAQI",
    ICQA: "ICQA",
    DIBA: "DIBA",
    ISPU: "ISPU",
    APIMS: "APIMS",
    AQHI: "AQHI",
    "AQHI-HK": "AQHI-HK",
    ICA: "ICA",
    "AQI-QB": "AQI-QB",
    "AQI-CH": "AQI-CH",
    DAQI: "DAQI",
    IQAR:"IQAR",
    "AQHI-MX": "AQHI-MX",
};

const concentrationUnits = {eu: 'eu', usa: 'usa'};

module.exports = {
    sensor,
    unit,
    indexList,
    concentrationUnits
};
